module.exports = __webpack_public_path__ + "static/media/Rice_cooker.745639ec.png";